"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMultiSymbolObserve = exports.setMultiSymbolObserve = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const rxjs_1 = require("rxjs");
const KEY_FUTURES_MULTI_SYMBOLS = "futures_multi_symbols";
const setMultiSymbolObserve = (symbol, value) => {
    return (0, exports.getMultiSymbolObserve)().pipe((0, rxjs_1.mergeMap)((set) => {
        if (value) {
            set.add(symbol);
        }
        else {
            set.delete(symbol);
        }
        return (0, rxjs_1.of)((0, trade_utils_lib_1.getLocalStorage)().setItem(KEY_FUTURES_MULTI_SYMBOLS, JSON.stringify(Array.from(set))));
    }));
};
exports.setMultiSymbolObserve = setMultiSymbolObserve;
const getMultiSymbolObserve = () => {
    return (0, trade_utils_lib_1.getLocalStorage)()
        .getItem(KEY_FUTURES_MULTI_SYMBOLS)
        .pipe((0, rxjs_1.map)((item) => new Set(JSON.parse(item))), (0, rxjs_1.catchError)(() => (0, rxjs_1.of)(new Set())));
};
exports.getMultiSymbolObserve = getMultiSymbolObserve;
